import { default as serverConfigData } from './serviceConfig.json';
import { default as paymentConfigData } from './paymentConfig.json';

const serverEnv = 'backend.leaderly.in';
export const serverConfig = {
  serverBaseAddress: serverConfigData[serverEnv],
  razorPayKey: paymentConfigData[serverEnv],

};
